import * as React from "react"

function SentGift(props: any) {
  return (
    <svg
      width={93}
      height={100}
      viewBox="0 0 93 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1_661)" fill={props.fill} fillOpacity={0.7}>
        <path d="m61.622 36.63c-.153.001-23.442-.007-23.442-.007l-2.244 10.319h23.444z"/><path d="m48.181 32.042c1.513 1.143 8.805 1.637 13.417 1.581-1.202-4.814-3.195-10.868-4.713-12.015-2.291-1.73-6.104-.763-8.498 2.159-1.958 2.39-3.014 6.154-.206 8.275z"/><path d="m37.509 49.941-6.371 29.299h21.218l6.371-29.299z"/><path d="m79.771 31.935c3.213-1.828 5.01-5.757 3.924-8.581-1.16-3.017-4.805-3.101-7.375-1.64-2.408 1.37-7.161 7.78-10.019 11.908h.081c4.417-.038 11.089-.379 13.389-1.687z"/><path d="m55.427 79.24h21.219l6.371-29.299h-21.219z"/><path d="m62.45 46.941h23.445l2.244-10.318h-23.445z"/><path d="m27.671 62.552c0-.829-.672-1.5-1.5-1.5h-12.652c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5h12.652c.828 0 1.5-.671 1.5-1.5z"/><path d="m31.238 50.337c0-.829-.672-1.5-1.5-1.5h-18.362c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5h18.362c.828 0 1.5-.671 1.5-1.5z"/><path d="m18.913 39.623h12.731c.828 0 1.5-.671 1.5-1.5s-.672-1.5-1.5-1.5h-12.731c-.828 0-1.5.671-1.5 1.5s.671 1.5 1.5 1.5z"/><path d="m17.594 71.153c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5h5.926c.828 0 1.5-.671 1.5-1.5s-.672-1.5-1.5-1.5z"/>      </g>
      <defs>
        <clipPath id="clip0_1_661">
          <path fill="#fff" d="M0 0H93V100H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SentGift
